module.exports = __webpack_public_path__ + "static/media/23.862dc1ae.JPG";